// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__CzULP","card":"Cards_card__1x2cY","infected":"Cards_infected__2AeeN","recovered":"Cards_recovered__XuDhr","deaths":"Cards_deaths__1Jj5c"};